import { GEOFENCE_ALERT_MODES, MAP_DATA_SOURCE } from '@constants/map';

export function updateData({ map, geoJSON }) {
	const geofences = geoJSON[MAP_DATA_SOURCE.geofences];
	const botLocation = geoJSON[MAP_DATA_SOURCE.botLocation];

	if (geofences) {
		updateGeofenceSource({
			map,
			geoJSON: geofences,
			alertMode: GEOFENCE_ALERT_MODES.safe_zone
		});
	}

	if (botLocation) {
		updateBotLocationSource({ map, geoJSON: botLocation });
	}
}

function updateGeofenceSource({ map, geoJSON, alertMode }) {
	const sourceName = `${MAP_DATA_SOURCE.geofences}-${alertMode.name}`;
	const source = map.getSource(sourceName);
	
	if (!source) {
		// Source doesn't exist, skip update (probably removed when switching map modes)
		return;
	}

	const features = geoJSON.features.filter((geofence) => geofence.properties.alertMode === alertMode.name);

	const data = {
		features: features,
		type: 'FeatureCollection'
	};

	source.setData(data);
}

function updateBotLocationSource({ map, geoJSON }) {
	const source = map.getSource(MAP_DATA_SOURCE.botLocation);

	if (source) {
		source.setData(geoJSON);
	} else {
		map.addSource(MAP_DATA_SOURCE.botLocation, {
			type: 'geojson',
			data: geoJSON
		});

		map.addLayer({
			id: MAP_DATA_SOURCE.botLocation,
			type: 'circle',
			source: MAP_DATA_SOURCE.botLocation,
			paint: {
				'circle-radius': 8,
				'circle-color': '#007cbf',
				'circle-stroke-width': 2,
				'circle-stroke-color': '#ffffff'
			}
		});

		map.addLayer({
			id: `${MAP_DATA_SOURCE.botLocation}-label`,
			type: 'symbol',
			source: MAP_DATA_SOURCE.botLocation,
			layout: {
				'text-field': ['get', 'name'],
				'text-font': ['Open Sans Regular', 'Arial Unicode MS Regular'],
				'text-size': 12,
				'text-offset': [0, 2],
				'text-anchor': 'top'
			},
			paint: {
				'text-color': '#000000',
				'text-halo-color': '#ffffff',
				'text-halo-width': 1
			}
		});
	}
}
